<template>
<!--  -->
  <div class='policy-release'>
    <div style="margin-bottom: 20px">
      <CarouselPage></CarouselPage>
    </div>
    <div style=' margin: 0px 8%;'>
        <div class='search-action'>
            <div class="title"><Icon type="md-search" style="font-size: 20px" />筛选条件</div>
            <div class="content">
                <div class='form'>
                <Form :model="searchParam" inline :label-width="150" label-position="right">
                    <Row>
                        <!-- <Col :xs="12" :sm="12" :md="12" :lg="12">
                            <FormItem label="发布状态：" style="width: 100%">
                            <div class='cover-b-l-t-l'>
                                <p
                                v-for='item in blackListTypeList'
                                :key='"b-l-t-l-" + item.dicCode'
                                @click='searchParam.blackCategory = item.dicCode'
                                :class='{"b-l-t-l": true, action: searchParam.blackCategory === item.dicCode}'
                                >{{item.dicName}}</p>
                            </div>
                            </FormItem>
                        </Col> -->
                        <Col :xs="12" :sm="12" :md="12" :lg="12">
                            <FormItem label="征信类别对象：" style="width: 100%">
                            <div class='cover-b-l-t-l'>
                                <p style="width:50%"
                                v-for='item in classList'
                                :key='"b-l-t-l-" + item.dicCode'
                                @click='classType = item.dicCode'
                                :class='{"b-l-t-l": true, action: classType === item.dicCode}'
                                >{{item.dicName}}</p>
                            </div>
                            </FormItem>
                        </Col>
                        <Col :xs="12" :sm="12" :md="12" :lg="12">
                            <FormItem label="诚信行为性质：" style="width: 100%">
                            <div class='cover-b-l-t-l'>
                                <p
                                v-for='item in creditInfoTypeList'
                                :key='"b-l-t-l-" + item.dicCode'
                                @click='searchParam.creditStatus = item.dicCode'
                                :class='{"b-l-t-l": true, action: searchParam.creditStatus === item.dicCode}'
                                >{{item.dicName}}</p>
                            </div>
                            </FormItem>
                        </Col>
                        <Col :xs="8" :sm="8" :md="12" :lg="12">
                            <FormItem label="诚信记录主体：" style="width: 100%">
                                <Input v-model="searchParam.corpName" clearable search placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <Col :xs="12" :sm="8" :md="12" :lg="12">
                            <FormItem label="实施部门名称：" style="width: 100%">
                                <Input v-model="searchParam.affirmDepartment" clearable search placeholder="请输入"></Input>
                            </FormItem>
                        </Col>
                        <Col offset='12' :xs="12" :sm="8" :md="12" :lg="12">
                            <FormItem  style="width: 100%">
                                <Button style="width: 100px;float:right;margin-left:20px;" @click="handleInitParam">重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置</Button>
                                <Button type="primary" @click='handleSearch' style="width: 100px;float:right;">开始查询</Button>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                </div>
                <!-- <div class='action'>
                    <Button type="primary" @click='handleSearch' style="width: 100px; margin-bottom: 10px">开始查询</Button>
                    <Button style="width: 100px;" @click="handleInitParam">重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置</Button>
                </div> -->
            </div>
        </div>
        <div class="cover-table" v-if="classType == 1">
            <Table :columns="columns" border :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <div class="table-btn" style="cursor:pointer;" @click="handleDeal('creditInfoDetail',row.uuid, true)">{{row.corpName}}</div>
                </template>
            </Table>
            <div class="t-page">
                <Page class-name='pageBorder' :total="totalCount" :page-size="searchParam.pageSize" :current="searchParam.page"
                        @on-change="changePage" @on-page-size-change="pageSizeChange"
                        show-elevator show-sizer show-total transfer>
                </Page>
            </div>
        </div>
        <div class="cover-table" v-if="classType == 2">
            <Table :columns="personColumns" border :data="grcxxx" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <div class="table-btn" style="cursor:pointer;" @click="handleDeal('creditInfoDetail',row.uuid, true)">{{row.corpName}}</div>
                </template>
            </Table>
            <div class="t-page">
                <Page class-name='pageBorder' :total="personTotal" :page-size="size" :current="page"
                        @on-change="personPage" @on-page-size-change="personSize"
                        show-elevator show-sizer show-total transfer>
                </Page>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tableMixin from '@/components/tableMixin';
import { getCreditInfoList,personalIntegritys } from '@/api/homePage.js'
import CarouselPage from './carouselPage.vue'

export default {
  name: '',
  props: {

  },
  data () {
    return {
        carousel: 0,
        imgList: [],
        totalCount:10,
        classType:1,
        classList:[
            {dicName:'工程建设企业',dicCode:1},
            {dicName:'从业人员',dicCode:2}
        ],
        creditInfoTypeList:[
            {
                dicName: '全部',
                dicCode: 2
            }, {
                dicName: '良好行为',
                dicCode: 0
            }, {
                dicName: '不良行为',
                dicCode: 1
            }
        ],
        blackListTypeList: [
            {
                dicName: '全部',
                dicCode: 0
            }, {
                dicName: '工程建设企业',
                dicCode: 1
            }, {
                dicName: '从业人员',
                dicCode: 2
            }
        ],
        grcxxx:[],
        num:1,
        size:10,
        personTotal:0,
        personData:{

        },
        searchParam: {
            creditStatus:2,
            corpName:'',
            affirmDepartment:'',
            page:1,
            pageSize:10
        },
        personColumns: [
            {
                title: '诚信记录编码',
                key: 'creditNumbe',
                width: 150,
                align: 'center',
                className: 'cell-hmd'
            },
            {
                title: '诚信信息类型',
                key: 'creditNature',
                width: 150,
                align: 'center',
                render(row,column,index) {
                    let str = column.row.creditNature
                    if(column.row.creditNature == '良好信用') {
                        return row('span',{
                            style:{
                                background:'#33CC00',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },'良好信用' )
                    }else if(column.row.creditNature == '严重不良信用'){
                        return row('span',{
                            style:{
                                background:'#FF0000',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },str )
                    }else if(column.row.creditNature == '一般不良信用'){
                        return row('span',{
                            style:{
                                background:'#FF4400',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },str )
                    }else if(column.row.creditNature == '轻微不良信用'){
                        return row('span',{
                            style:{
                                background:'#FF7700',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },str )
                    }
                }
            },
            {
                title: '姓名',
                key: 'personName',
                align: 'center',
                width: 90,
                className: 'cell-hmd'
            },
            {
                title: '身份证号',
                key: 'idCard',
                align: 'center',
                width: 170,
                className: 'cell-hmd'
            },

            {
                title: '决定内容',
                key: 'fContent',
                align: 'center',
                minWidth:280,
                className:'mark',
                render: (h, params) => {

                    return h('div', [
                        h('span', {
                            domProps: {title: params.row.mark},
                            on:{click:(e) => { e.stopPropagation();}}
                        }, params.row.mark)
                    ]);
                }
            },
            {
                title: '实施部门',
                key: 'departName',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            },
            {
                title: '发布有效期',
                key: 'openDate',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            }
        ],
        columns: [
            {
                title: '诚信记录编码',
                key: 'creditCode',
                width: 150,
                align: 'center',
                className: 'cell-hmd'
            },
            {
                title: '诚信信息类型',
                key: 'creditStatus',
                width: 150,
                align: 'center',
                render(row,column,index) {
                    let str = column.row.creditStatus
                    if(column.row.creditStatus == '良好信用') {
                        return row('span',{
                            style:{
                                background:'#33CC00',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },'良好信用' )
                    }else if(column.row.creditStatus == '严重不良信用'){
                        return row('span',{
                            style:{
                                background:'#FF0000',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },str )
                    }else if(column.row.creditStatus == '一般不良信用'){
                        return row('span',{
                            style:{
                                background:'#FF4400',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },str )
                    }else if(column.row.creditStatus == '轻微不良信用'){
                        return row('span',{
                            style:{
                                background:'#FF7700',
                                color:'white',
                                borderRadius: '3px',
                                width:'100px',
                                display:'block',
                                margin:'0 auto',
                                fontSize: 'smaller'
                            }
                        },str )
                    }
                }
            },
            {
                title: '诚信记录主体',
                key: 'corpName',
                align: 'center',
                width: 200,
                slot:'action',
            },
            {
                title: '法人',
                key: 'legalMan',
                align: 'center',
                width: 110,
                className: 'cell-hmd'
            },
            {
                title: '决定内容',
                key: 'mark',
                align: 'center',
                minWidth:280,
                className:'mark',
                render: (h, params) => {

                    return h('div', [
                        h('span', {
                            domProps: {title: params.row.mark},
                            on:{click:(e) => { e.stopPropagation();}}
                        }, params.row.mark)
                    ]);
                }

            },
            {
                title: '实施部门',
                key: 'affirmDepartment',
                align: 'center',
                width: 160,
                className: 'cell-hmd'
            },
            {
                title: '发布有效期',
                key: 'publicDate',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            }
        ],
        tableData: []
    }
  },
  mixins: [tableMixin],
  components: {
    CarouselPage
  },
  computed: {

  },
  watch: {

  },
  created () {
      this.initData()
  },
  mounted () {

  },
  methods: {
    handleSearch() {
        if(this.classType == 1) {
            this.getTableData()
        }else{
            this.initData()
        }
    },
    handleInitParam() {
        this.searchParam = {
            creditStatus:'',
            corpName:'',
            affirmDepartment:'',
            page:1,
            pageSize:10
        }
    },
    personSize(value) {
        this.size = value
        this.initData()
    },
    personPage(value) {
        this.page = value
        this.initData()
    },
    pageSizeChange(value){
        this.searchParam.pageSize = value
        this.getTableData()
    },
    changePage(value) {
        this.searchParam.page = value
        this.getTableData()
    },
    initData() {
        let behaviorType = ''
        if(this.searchParam.creditStatus == 2) {

        }else {
            behaviorType = this.searchParam.creditStatus
        }
        let grcxxx = {
            num:this.num,
            size:this.size,
            behaviorType:behaviorType
        }
        personalIntegritys(grcxxx).then((res) => {
            // console.log(res)
            this.personTotal = res.data.data.total
            this.grcxxx = res.data.data.list
        }).catch(() => {
            this.$Message.error('获取列表信息失败')
        })
    },
    // 获取表格数据
    getTableData() {
      getCreditInfoList(this.searchParam).then((res) => {
        // console.log(res)
        if (!res) return this.$Message.error('获取列表信息失败')
        this.totalCount = res.data.totalCount
        this.tableData = res.data.data
      }).catch(() => {
        this.$Message.error('获取列表信息失败')
      })
    },
    /*处理操作*/
    handleDeal(name, uuid){
        this.$router.push({
            name: name,
            query: {
                uuid
            }
        });
    },
    handleTypeChange(val) {

    }
  }
}
</script>

<style lang="less" scoped>
  .policy-release {
    background: #f5f5f5;
    height: 100%;
    padding: 0 0 20px 0;
    .cover-table {
      background: #fff;
      border-radius: 4px;
      padding: 15px 15px 0;
    }
  }
</style>
<style lang="less">
    .cover-table {
        .cell-hmd {
        padding: 0px;
        color: #808080;
        }
        .color-black08 {
        color: #808080;
        }
  }
  .search-action {
    background: #fff;
    margin: 15px 0;
    &>.title {
      // height: 30px;
      font-size: 18px;
      padding: 8px 12px;
      line-height: 22px;
      border-bottom: 2px solid #EFEFEF;
    }
    &>.content {
      padding: 15px 0 0 ;
      display: flex;
      flex-direction: row;
      &>.form {
        flex: 1;
        padding: 0 20px;
        .cover-b-l-t-l {
          height: 34px;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .b-l-t-l {
            width: 33%;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #0180DD;
            border-radius: 3px;
            cursor: pointer;
          }
          .b-l-t-l.action {
            color: #fff;
            background: #0180DD;
          }
        }

      }
      &>.action {
        width: 170px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
    .mark {
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: 48px;
        color: #808080;
    }
    .pageBorder {
        .ivu-page-item {
            border-radius: 100%;
        }
        .ivu-page-prev {
            border-radius: 100%;
        }
        .ivu-page-next {
            border-radius: 100%;
        }
        .ivu-page-next {
            border-radius: 30px;
        }
        .ivu-page-options-elevator input {
            border-radius: 30px;
        }
    }
</style>
<style lang="less">
  .tables {
    /deep/.ivu-tabs-nav-scroll {
      background: #fff;
    }
  }
</style>
